import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import transaction from '@apis/transaction'
import styled from '@emotion/styled'
import Container from '@components/container'
import {
  Button,
  StatusCard,
  StatusIcon,
  StatusMessage,
  StatusTitle,
} from './style'

// Simple Loader
const Loader = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const PaymentStatus = () => {
  const location = useLocation()
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>(
    'pending',
  )
  const [message, setMessage] = useState('Processing your payment...')
  const navigate = useNavigate()
  const [res, setRes] = useState<any>(null)

  // Parse query params
  const queryParams = new URLSearchParams(location.search)
  const requestId = queryParams.get('requestId')?.split('?')[0]
  const method = queryParams.get('method')

  useEffect(() => {
    const verifyPayment = async () => {
      if (!requestId || !method) {
        setStatus('error')
        setMessage('Missing requestId or method.')
        return
      }

      const payload = {
        requestId,
        method: method || 'esewa',
      }

      try {
        const res = await transaction.verifyPayment({ data: payload })
        setRes(res)
        if (res && Object.keys(res).length > 0) {
          setStatus('success')
          setMessage('Payment successful! Redirecting...')
          setTimeout(() => {
            window.location.href = `https://bus.inflancer.com/payment-status?type=success&bookingId=${res.bookingId}`
          }, 400)
        } else {
          setStatus('error')
          setMessage('Payment verification failed. Redirecting...')
          setTimeout(() => {
            window.location.href = `https://bus.inflancer.com/payment-status?type=failed&bookingId=${res.bookingId}`
          }, 400)
        }
      } catch (err: any) {
        setStatus('error')
        setMessage('An error occurred. Redirecting...')
        setTimeout(() => {
          window.location.href = `https://bus.inflancer.com/payment-status?type=failed&bookingId=${res.bookingId}`
        }, 400)
      }
    }

    verifyPayment().then(() => {})
  }, [requestId, method, navigate])

  const getStatusIcon = () => {
    switch (status) {
      case 'success':
        return '✓'
      case 'error':
        return '✕'
      default:
        return '⟳'
    }
  }

  return (
    <Container>
      {res && <pre>{JSON.stringify(res, null, 2)}</pre>}

      <StatusCard>
        <StatusIcon status={status}>{getStatusIcon()}</StatusIcon>
        <StatusTitle>Payment Status: {status.toUpperCase()}</StatusTitle>
        <StatusMessage>{message}</StatusMessage>

        {status === 'pending' && (
          <div style={{ marginTop: '1rem' }}>
            <Loader />
            <p style={{ fontSize: '0.9rem', marginTop: '0.5rem' }}>
              Redirecting...
            </p>
          </div>
        )}

        {status !== 'pending' && (
          <Button onClick={() => navigate('/')}>Return Home</Button>
        )}
      </StatusCard>
    </Container>
  )
}

export default PaymentStatus
